import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function PainPoints() {
  const ref = useScrollAnimation();
  const pains = ['Pasás horas buscando actividades que nunca terminan de convencerte', 'Improvisás clase a clase porque no llegás a planificar', 'Sentís que tus clases de arte podrían ser mucho mejores', 'Los domingos los perdés armando material desde cero', 'No encontrás recursos que se adapten al currículo argentino'];
  return <section className="w-full bg-[#0a0a0a] py-24 px-4 border-t border-[#1a1a1a] pt-[40px] pb-[40px]" ref={ref} data-id="element-161">
      <div className="max-w-3xl mx-auto" data-id="element-162">
        <h2 className="scroll-hidden text-4xl md:text-5xl font-bold text-white text-center mb-12" style={{
        fontFamily: 'Georgia, serif'
      }} data-id="element-163">
          ¿Te suena familiar?
        </h2>

        <div className="space-y-4 mb-16" data-id="element-164">
          {pains.map((pain, index) => <div key={index} className="scroll-hidden bg-[#141414] border border-[#2a2a2a] rounded-lg p-5 flex items-start gap-4" style={{
          transitionDelay: `${index * 100}ms`
        }} data-id="element-165">
              <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-166">❌</span>
              <p className="text-gray-300 text-lg" data-id="element-167">{pain}</p>
            </div>)}
        </div>

        <div className="scroll-hidden bg-[#F5C518]/10 border border-[#F5C518]/30 rounded-xl p-8 text-center" data-id="element-168">
          <span className="text-4xl block mb-4" data-id="element-169">✅</span>
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-170">
            Con el Mega Pack de Arte, todo eso se termina.
          </h3>
          <p className="text-[#F5C518] text-lg" data-id="element-171">
            Tenés el año resuelto. Literalmente.
          </p>
        </div>
      </div>
    </section>;
}